import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ContextProvider } from './contexts/store';
import App from 'app/App';
import {  store } from 'globals/app';


const rootEl = document.getElementById('root');

const render = (Component: React.ComponentType) => {
ReactDOM.render(
	 <Provider store={store}>
      <ContextProvider>
		  <App />
	 </ContextProvider>
	 </Provider>,
    rootEl);
};

render(App);

// Hot Module Replacement API
declare let module: { hot: any };